import "./index.scss";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SubmitBtn from "../submitButton";
import PasswordInput from "../passwordInput";
import { login } from "../../services/user.service";
// import { useTranslation } from "react-i18next";

function LoginForm() {
  const [loading, setloading] = useState(false);
  const [errors, setErrors] = useState({ hasError: false, msg: "" });
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  // const { t } = useTranslation();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    setErrors({ hasError: false, msg: "" });

    if (!formData.email || !formData.password) {
      setErrors({
        hasError: true,
        msg: "L'email et le mot de passe sont requis!",
      });
      setloading(false);
      return;
    }

    const res = await login(formData.email, formData.password);
    console.log("res.success", res);
    if (res.success) {
      setloading(false);
      if (res?.userData?.user?.role === "client") {
        setTimeout(() => {
          navigate("/devis");
          window.location.reload();
        }, 1000);
      } else if (res?.userData?.user?.role === "admin") {
        setTimeout(() => {
          navigate("/users");
          window.location.reload();
        }, 1000);
      } else {
        {
          setTimeout(() => {
            navigate("/clientsDevisList");
            window.location.reload();
          }, 1000);
        }
      }
    } else {
      setErrors({
        hasError: true,
        msg: res.msg,
      });
      setloading(false);
    }
  };

  return (
    <form
      id="LoginForm"
      className="form-group"
      onSubmit={handleSubmit}
      aria-busy={loading}>
      <div className="error-msg">{errors.hasError && <p>{errors.msg}</p>}</div>
      <div className="row">
        <input
          type="email"
          name="email"
          id="email"
          className="form__input"
          autoComplete="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Adresse email"
        />
      </div>
      <div className="row">
        <PasswordInput
          type="password"
          name="password"
          id="password"
          className="form__input"
          autoComplete="current-password"
          value={formData.password}
          onChange={handleChange}
          placeholder="Mot de passe"
        />
        <div className="d-flex justify-content-between align-items-center  p-3 ">
          {/* Checkbox Se souvenir de moi */}
          <div className="remember-me d-flex align-items-center">
            {/* <input type="checkbox" id="remember" className="me-2" />
            <label htmlFor="remember">Se souvenir de moi</label> */}
          </div>

          {/* Lien mot de passe oublié */}
          <div className="forgot-pwd">
            <a href="/forgot-pwd" className="forgotpassword">
              Mot de passe oublié
            </a>
          </div>
        </div>
      </div>
      <SubmitBtn value={"Se connecter"} disabled={loading} />
    </form>
  );
}

export default LoginForm;
